function reloadCart(reloadRecs = true){
    fetch(`/cart?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const isEmpty = html.querySelector('.is-empty');
    const cartContents = document.querySelector('.cart-drawer-items .cart__contents');
    if(isEmpty){
        cartContents.classList.add('is-empty');
    } else {
        cartContents.classList.remove('is-empty');
    }
    const targetElements = document.querySelectorAll('.cart-drawer-items [data-cart]');
    targetElements.forEach(targetElement => {
        const selector = `.${targetElement.dataset.cart}`;
        if(!reloadRecs && selector == '.recommended_products'){
        return;
        }
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
        }
    });

    if(reloadRecs){
        loadRecommendedProducts(); // Load recommendations dynamically
    }

    setTimeout(function(){
        $(".item-count").html($("#cart-drawer-title").attr("data-count"));
    },100);
    })
    .catch((e) => {
    console.error(e);
    });
}

function loadRecommendedProducts() {
    fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
    var recContainer = document.querySelector('.recommended_products');
    if (!recContainer) return;

    var recommendedEnable = recContainer.getAttribute('data-recommended-enable') === 'true';
    var trendingEnable = recContainer.getAttribute('data-trending-enable') === 'true';
    var cartCount = cartData.item_count;
    var shouldShow = false;

    if (recommendedEnable && trendingEnable) {
        shouldShow = true;
    }
    else if (!recommendedEnable && trendingEnable && cartCount === 0) {
        shouldShow = true;
    }
    else if (recommendedEnable && !trendingEnable && cartCount > 0) {
        shouldShow = true;
    }

    if (!shouldShow) {
        recContainer.style.display = 'none';
        return;
    } else {
        recContainer.style.display = 'block';
    }
    if (cartData.items && cartData.items.length > 0) {
        const productId = cartData.items[0].product_id;
        fetch(`/recommendations/products.json?product_id=${productId}&limit=10`)
        .then((response) => response.json())
        .then((data) => {
            console.log('Recommendations data:', data);
        
        const recommendationsContainer = document.querySelector('#recommended-products-list');
        if (data.products && data.products.length > 0 && recommendationsContainer) {
            recommendationsContainer.innerHTML = '';
            const sortedRecs = data.products.sort(
                (a, b) => new Date(b.published_at) - new Date(a.published_at)
            );
            
                sortedRecs.forEach((product) => {
                // Check if the first available variant is 'Audio book'
                const variantTitle = product.variants[0].title.toLowerCase();
                const isAvailable = product.variants[0].available;

                console.log('variant-title' + variantTitle);
                if (!/audio[-\s]*book/i.test(variantTitle) && !/e[-\s]*book/i.test(variantTitle) && !/\[hidden\]/i.test(variantTitle) && isAvailable) {
                    buildSlide(product,recommendationsContainer);
                }
                });
                buildSlider();

        } else {
            console.log('No recommended products available from API.');
            buildSlider();
        }
        })
        .catch((error) => {
        console.error('Error loading recommendations:', error);
        buildSlider();
        });
    } else if (cartData.items.length === 0 && trendingEnable) {
        const recommendationsContainer = document.querySelector('#recommended-products-list');
        recommendationsContainer.innerHTML = '';
      
        const trendingHandle = recContainer.getAttribute('data-trending-handle');
        fetch(`/collections/${trendingHandle}/products.json?limit=10`)
          .then((r) => r.json())
          .then((data) => {
            const newestFirst = data.products.sort(
              (a, b) => new Date(b.published_at) - new Date(a.published_at)
            );
            newestFirst.forEach((product) => {
              const variant = product.variants[0];
              const title = variant.title.toLowerCase();
              const isAvailable = variant.available;
      
              if (
                isAvailable &&
                !/audio[-\s]*book/i.test(title) &&
                !/e[-\s]*book/i.test(title) &&
                !/\[hidden\]/i.test(title)
              ) {
                buildSlide(
                  {
                    url: product.url,
                    title: product.title,
                    featured_image: product.images[0]?.src || '',
                    variants: [{
                      id:            variant.id,
                      title:         variant.title,
                      price:         variant.price,
                      compare_at_price: variant.compare_at_price
                    }]
                  },
                  recommendationsContainer
                );
              }
            });
      
            buildSlider();
          })
          .catch((err) => {
            console.error('Error loading trending products:', err);
            buildSlider();
          });
      } else {
        buildSlider();
      }
    })
    .catch((error) => {
    console.error('Error loading cart data:', error);
    })
}

function buildSlide(product,container){
    console.log('Building slide for product:', product);
    const priceFormatted = (product.variants[0].price / 100).toFixed(2);
    const compareAtPriceFormatted = product.variants[0].compare_at_price ? (product.variants[0].compare_at_price / 100).toFixed(2) : null;

    var slide = document.createElement('li');
    slide.classList.add('swiper-slide');
    slide.innerHTML = `
    <div>
        <a class="d-flex justify-content-center" href="${product.url}">
        <img class="recommended_product--image" src="${product.featured_image}" alt="${product.title}">
        </a>
        <div class="product_meta">
        <h5>
            <a href="${product.url}">${product.title}</a>
        </h5>
        <p>${product.variants[0].title}</p>
        </div>
        <div>
        ${compareAtPriceFormatted && compareAtPriceFormatted > priceFormatted ?
            `<span>
            <del>R$ ${compareAtPriceFormatted}</del>
            <ins>R$ ${priceFormatted}</ins>
            </span>` :
            `<span>R$ ${priceFormatted}</span>`
        }
        <button type="button" data-id="${product.variants[0].id}">Adicionar</button>
        </div>
    </div>
    `;
    container.appendChild(slide);
}

function buildSlider(){
    new Swiper(".swiper-addon-products", {
    slidesPerView: 2.2,
    spaceBetween: 5,
    observer: true,
    navigation: {
        prevEl: '#swiper-button-prev-swiper-addon-products',
        nextEl: '#swiper-button-next-swiper-addon-products'
    },
    });
}

function manageQty(qty,index){
    $.ajax({
    url:"/cart/change.js?line="+index+"&quantity="+qty,
    complete:function(){
        var reloadRecs = (parseInt(qty) == 0) ? true : false;
        reloadCart(reloadRecs);
        document.body.classList.remove("added-to-cart");
    }
    });
}
let lastAddedProductId = null;

document.addEventListener('DOMContentLoaded', function() {  
    $("body").on("click", ".cart [data-id]", function(){
        $(this).css({ "pointer-events": "none", "opacity": 0.5 });
        lastAddedProductId = $(this).data("id"); // Capture the product ID
        $.ajax({
        url: `/cart/add.js?id=${lastAddedProductId}`,
        complete: function(){
            reloadCart();
            //loadRecommendedProducts(lastAddedProductId); // Use the last added product ID
        }
        });
    });
    
    $("body").on("keyup",".cart-quantity input", function(){
        $(this).css({ "pointer-events":"none","opacity":0.5 });
        manageQty($(this).val(),$(this).parents(".product").data("index"));
    })
    
    $("body").on("click",".cart-quantity button", function(){
        $(this).css({ "pointer-events":"none","opacity":0.5 });
        let currentVal = Number($(this).parents(".cart-quantity").find("input").val());
        if($(this).attr("name") == "minus"){
        currentVal--
        } else{
        currentVal++
        }
        $(this).parents(".cart-quantity").find("input").val(currentVal);
        manageQty($(this).parents(".cart-quantity").find("input").val(),$(this).parents(".product").data("index"));
    });
    
    $("body").on("click",".trash_icon", function(){
        $(this).css({ "pointer-events":"none","opacity":0.5 });
        manageQty(0,$(this).parents(".product").data("index"));
    });
    
    $("body").on("click",".cart__close,.cart__overlay", function(){
        $(".se-cart,body").removeClass("_active");
    })
    
    const isCartPage = window.location.pathname === '/cart';
    let initCartDrawer = false;
    if (!isCartPage) {
        $("#shopify-section-header a[href='/cart']").on("click", function(e){
        var reloadRecs = !initCartDrawer
        reloadCart(reloadRecs);
        $(".se-cart,body").addClass("_active");
        e.preventDefault();
        initCartDrawer = true;
        });
    }
});